export default __webpack_public_path__ + "static/media/Stat1.4167ebfe.png";